import {useState, useEffect, useRef, useContext} from 'react';
import { useParams } from 'react-router';
import  { motion } from 'framer-motion';
import axios from 'axios';
import './Stylesheets/Portfolio.css';
import './Stylesheets/Global.css';
import {Category, CategoryIndex} from '../Interfaces/Category';
import {Post} from '../Interfaces/Post';
import { ScreenBusyContext } from '../../App';





export default function Gallery(){

    let params = useParams();

    const navContext = useContext(ScreenBusyContext);

    const {screenBusy, setScreenBusy} = navContext!; 

    const workOverlayRef = useRef<HTMLDivElement>(null);

    const [isLoading, setIsLoading] = useState(true);

    const [currentPage, setCurrentPage] = useState(1);

    const [maximumPage, setMaximumPage] = useState(1);

    const links: CategoryIndex = {
        "Photo Manipulation": 1,
        "Photography": 2,
        "Illustration": 3,
        "Publications": 4,
        "Logos": 5
    }

    const [category, setCategory] = useState<Category | null>(null);

    const [posts, setPosts] = useState<Post[]>([]);

    const [selectedWork, setSelectedWork] = useState<Post | null>(null);

    const backend_url = process.env.REACT_APP_BACKEND_URL;

    // Retrieve category information API GET
    useEffect(() => {

        // Query actual posts of the category
        axios.get(`${backend_url}/Blog/GetCategory/${links[params.category!]}`)
        .then(res => setCategory(res.data.content))

        // Query to get maximum page count of category
        axios.get(`${backend_url}/Blog/GetCategoryPageCount/${links[params.category!]}`)
        .then(res => {
            const pageCount = res.data.content;
            if (currentPage > pageCount) {
                setCurrentPage(pageCount);
            }
            setMaximumPage(pageCount + 1);
        })
    },[])


    useEffect(() => {
        if (!category) {return};
        setPosts([]);
        setIsLoading(true);
        axios.get(`${backend_url}/Blog/GetCategoryPosts/${category?.categoryId}?pageNumber=${currentPage}`)
        .then(res => setPosts(res.data.content))
        .finally(() => {
            setTimeout(() => {
                setIsLoading(false);
            }, 100)
            
        })
    },[category, currentPage]); 


    useEffect(() => {
        if (selectedWork != null){
            setScreenBusy(true);
        }else {
            setScreenBusy(false);
        }
        
    },[selectedWork])



    const handleWorkClick = (post: Post) => {
        setSelectedWork(post);
    }

    const renderWorkDetails = () => {

        if (selectedWork === null) { 
            return;
        }

        return ( 
           
   
                <div onClick={() => setSelectedWork(null)}className={"work-details-overlay"}>
                     <motion.div
                        ref={workOverlayRef}
                        className={"work-div"}
                        initial={
                        {
                            y: 100,
                            opacity: 0
                        }
                        }
                        animate={{
                        y: 0,
                        opacity: 1
                        }}
                        transition={{
                        duration: 0.3,
                        ease: "easeIn"
                        }}
                     >

                            <div className={"work-details"}>
                                <button style={{"alignSelf": "left", "margin": "10px", "backgroundColor": "white", "color": "black"}}onClick={() => setSelectedWork(null)} className={"close-button"}><span style={{"color": "var(--acYellow)"}}>《</span> Back</button>
                                {/* <h2>{selectedWork.postTitle}</h2>
                                <p>{selectedWork.postBody}</p> */}
                            </div>
                            
                            <img className={"work-details-image"}src={`${selectedWork.imageUrl}`} alt={selectedWork.postTitle} />
                            
                   
                    </motion.div>
                </div>
          
            
        )
    }

    const renderContent = () => {
        return (
            <div className={'gallery-items-container'}>
                {posts.map((post) => (
                    <div onClick={() => handleWorkClick(post)} key={post.postId} className={'gallery-item'}>
                        {post.imageUrl && (
                            <img loading={"lazy"} src={`${post.imageUrl}`} alt={post.postTitle} />
                          
                        )}
                    </div>
                ))}
            </div>
        )
    }


    const changePage = (newPage: number ) => {
        if (newPage > maximumPage || newPage < 0) {
            return;
        } else {
            setCurrentPage(newPage);
        }
    }
 
    return(
        <> 
        {selectedWork && renderWorkDetails()}
        <div className={'gallery-top-intro-div'}>
            <div className={'gallery-top-intro-text'}>
              <h1>{category?.categoryName}</h1>
              <hr></hr>
              <p>{category?.categoryDesc}</p>
            </div>
        </div>
        <div className={'gallery-items-div'}>

            { isLoading ? <div className={"loading-placeholder"}><h1 style={{color: "white", alignSelf: "center"}}>Loading Works...</h1></div> : renderContent()}
            <div className={'pagination'}>
                <button className={'pagination-button'} onClick={() => changePage(currentPage - 1)} disabled={currentPage === 1}>
                   《
                </button>
                <span style={{color: "white", fontSize: "clamp(1rem, 2vw, 2rem)"}}>{currentPage} / {maximumPage}</span>
                <button className={'pagination-button'} onClick={() => changePage(currentPage + 1)}>
                    》
                </button>
            </div>
            <a style={{textDecoration: "none", color: "white", fontWeight: "200", fontSize: "clamp(1rem, 2vw, 1.5rem)"}}href="/Portfolio"><span style={{"color": "orange"}}>《</span> Back To Category Selection</a>
        </div>
        </> 
    )
}
